import { type RouteObject, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ErrorPage } from 'src/components/ErrorPage';
import { CurrentAPIAnalyserView } from 'src/views/CurrentAPIAnalyserView';

const currentAPIAnalyserRoutes: Array<RouteObject> = [
  {
    path: '/current-api-analyser/:eventSlug',
    element: <CurrentAPIAnalyserView />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/current-api-analyser',
    element: <ErrorPage />,
    errorElement: <ErrorPage />,
  },
];

const router = createBrowserRouter(currentAPIAnalyserRoutes);

export const CurrentAPIAnalyserRouter = () => {
  return <RouterProvider router={router} />;
};
